export const article = document.querySelector('[data-article-listed]') as HTMLDivElement;

export const header = document.querySelector('header > .header-wrapper') as HTMLDivElement;

export const chapters: NodeListOf<HTMLDivElement> = article.querySelectorAll(
  '[data-article-listed-chapter]'
);

export const listedWrapper = document.querySelector(
  '[data-article-listed-wrapper]'
) as HTMLDivElement;

export const hasSelectElementPagination = document.querySelector(
  '[data-has-select-element-pagination]'
) as HTMLDivElement;

export const navigations: NodeListOf<HTMLElement> = listedWrapper.querySelectorAll(
  '.article-listed-navigation'
);

export const btnsPrev: NodeListOf<HTMLElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-prev]'
);

export const btnsPrevHref: NodeListOf<HTMLElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-prev] [data-article-listed-nav-prev-href]'
);

export const btnsNext: NodeListOf<HTMLElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-next]'
);

export const btnsNextHref: NodeListOf<HTMLElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-next] [data-article-listed-nav-next-href]'
);

export const btnsLast: NodeListOf<HTMLElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-last]'
);

export const cheapters = listedWrapper.querySelectorAll('.article-listed-chapter');

export const chapeterSelectors = listedWrapper.querySelectorAll('[data-article-listed-select]');

export const countersActiveChapter = listedWrapper.querySelectorAll('[data-active-chapter]');

export const dataChapterBoxWrappers = document.querySelectorAll('[data-chapter-box-wrapper]');

export const chapterContentRegWallBoxButtons = document.querySelectorAll(".article-listed-chapter .html-box-reg-wall__cta");
